import {
  Box,
  Container,
  Flex,
  Text,
  useToast
} from "@chakra-ui/react";

import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loading from "../../../../components/common/Loading";
import QuizQuestion from "../../../../components/trainer/courses/assignments/AnswerQuizQuestions";
import {
  IQuizQuestion
} from "../../../../models/assignments/quiz-question.model";
import trainerAssignmentService from "../../../../services/trainer/trainer-assignment.service";

const AnswerQuiz = () => {
  const { course_id } = useParams();
  const toast = useToast();
  const navigate = useNavigate();
  const [questions, setQuestions] = useState<IQuizQuestion[]>([]);

  // const [selectedquestionArray, setselectedquestionArray] = useState<any[]>([]);
  // const [selectedoptionArray, setselectedoptionArray] = useState<any[]>([]);
  const [selectedquestionArray, setselectedquestionArray] = useState<string[]>(
    []
  );
  const [selectedoptionArray, setselectedoptionArray] = useState<string[]>([]);
  const [questionHeaderRes, setquestionHeaderRes] = useState<any>();
  const [currentQuestionIndex, setCurrentQuestionIndex] = useState(0);
  const [currentQuestion, setCurrentQuestion] = useState<IQuizQuestion>();
  const [loading, setLoading] = useState(true);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // gets all questions
  useEffect(() => {
    const question_header = sessionStorage.getItem("ques_head_info");
    if (question_header) {
      setquestionHeaderRes(JSON.parse(question_header));
      trainerAssignmentService
        .getAssignmentQuestions(JSON.parse(question_header).uuid)
        .then((res) => {
          setQuestions(res.data);
          setLoading(false);
        });
    }
  }, []);

  useEffect(() => {
    if (questions.length > 0) {
      updateCurrentQuestion();
    }
  }, [currentQuestionIndex, questions]);

  useEffect(() => {
    if (isSubmitting) {
      submitAnswers();
    }
  }, [isSubmitting]);

  const updateCurrentQuestion = () => {
    if (questions.length > 0) {
      const currentQuestion: IQuizQuestion = questions[currentQuestionIndex];
      setCurrentQuestion(currentQuestion);
    }
  };

  const submitAnswers = async () => {
    const submit_data = {
      question_header_id: questionHeaderRes.id,
      questions: selectedquestionArray,
      answers: selectedoptionArray,
    };

    try {
      const submit_user_answers =
        await trainerAssignmentService.answerQuizQuestions(
          course_id,
          submit_data
        );
      if (submit_user_answers) {
        toast({
          title: "Quiz Completed",
          description: "",
          status: "success",
          duration: 3000,
        });
        navigate(-1);
      }
    } catch (error) {
      console.error("Error submitting answers:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  const handleAnswer = (answer: number) => {
    if (currentQuestion) {

      setselectedoptionArray((prev) => {
        const updatedAnswers = [...prev, answer.toString()];
        return updatedAnswers;
      });

      setselectedquestionArray((prev) => {
        const updatedQuestions = [...prev, currentQuestion.id.toString()];
        return updatedQuestions;
      });

      if (currentQuestionIndex === questions.length - 1) {
        setIsSubmitting(true);
      } else {
        setCurrentQuestionIndex((prevIndex) => prevIndex + 1);
      }
    } else {
      console.error("No current question found.");
    }
  };



  return (
    <>
      {loading ? (
        <Loading />
      ) : (
        <Box minHeight="100vh" bg="#F9F8F8">
          <Box position="fixed" zIndex="1" width="100%">
            <Box>
              <Flex
                px={12}
                height="70px"
                bg="#FFFFFF"
                color="#616161"
                direction="row"
                alignItems="center"
                justifyContent="space-between"
              >
                <Box mx={"auto"} my="auto">
                  <Text
                    pt="15px"
                    color="#959595"
                    fontWeight={"600"}
                    bg="white"
                    fontSize={"24px"}
                    mr="20px"
                    width="100%"
                    textTransform={"capitalize"}
                    height="70px"
                  >
                    {questionHeaderRes.title}
                  </Text>
                </Box>
              </Flex>
            </Box>
          </Box>

          <Container
            width={"800px"}
            maxWidth={"84%"}
            px={0}
            pt="100px"
            right={0}
            bg="F9F8F8"
            mx="auto"
          >
            <Box bg="white" px={"20px"} py={"15px"}>
              {currentQuestion && (
                <QuizQuestion
                  question={currentQuestion.question}
                  options={currentQuestion.question_options}
                  onAnswer={handleAnswer}
                  totalQuestion={questions.length}
                  currentQuestionIndex={currentQuestionIndex}
                />
              )}
            </Box>
          </Container>
        </Box>
      )}
    </>
  );
};

export default AnswerQuiz;
